import { VIDEO_QUALITY_LABELS } from '@/lib/video-qualities'

export const PLYR_I18N = {
  restart: 'Yeniden başlat',
  rewind: 'Geri sar {seektime}s',
  play: 'Oynat',
  pause: 'Duraklat',
  fastForward: 'İleri sar {seektime}s',
  seek: 'İlerle',
  seekLabel: '{currentTime} / {duration}',
  played: 'Oynatıldı',
  buffered: 'Önbellek',
  currentTime: 'Geçen süre',
  duration: 'Süre',
  volume: 'Ses',
  mute: 'Sesi kapat',
  unmute: 'Sesi aç',
  enableCaptions: 'Altyazıları aç',
  disableCaptions: 'Altyazıları kapat',
  download: 'İndir',
  enterFullscreen: 'Tam ekran',
  exitFullscreen: 'Tam ekrandan çık',
  frameTitle: 'Oynatıcı: {title}',
  captions: 'Altyazılar',
  settings: 'Ayarlar',
  pip: 'Picture-in-Picture',
  menuBack: 'Geri git',
  speed: 'Hız',
  normal: 'Normal',
  quality: 'Kalite',
  loop: 'Döngü',
  start: 'Başlat',
  end: 'Bitir',
  all: 'Tümü',
  reset: 'Sıfırla',
  disabled: 'Kapalı',
  enabled: 'Açık',
  advertisement: 'Reklam',
  qualityLabel: VIDEO_QUALITY_LABELS,
  qualityBadge: {
    4320: '8K',
    2160: '4K',
    1440: 'HD',
    1080: 'HD',
    720: 'HD',
    576: 'SD',
    480: 'SD',
    360: 'SD',
  },
}
